import { useOperatorShortQuery, usePartnerShortQuery } from '@common/cache';
import { useBuildingTableStore } from '../filters.store';
import { isEqual, omit } from 'lodash';
import { SelectChangeEvent } from '@mui/material';

export const useFiltersCard = () => {
  const {
    filters,
    draftFilters,
    setDraftFilters,
    handleToggleFiltersCard,
    resetFilters,
    applyDraftFilters,
    draftFiltersCount,
  } = useBuildingTableStore();

  const { data: partnerShortOptions = [] } = usePartnerShortQuery();
  const { data: operatorShortOptions = [] } = useOperatorShortQuery();

  const handleChangePartnerFilter = (e: SelectChangeEvent<string>) => {
    setDraftFilters({ ...draftFilters, partner_id: e.target.value as string });
  };

  const handleChangeOperatorFilter = (e: SelectChangeEvent<string>) => {
    setDraftFilters({ ...draftFilters, operator_id: e.target.value as string });
  };

  const handleChangeStateFilter = (e: SelectChangeEvent<string>) => {
    setDraftFilters({ ...draftFilters, state: e.target.value as string });
  };

  const isResetDisabled = draftFiltersCount === 0;
  const isApplyDisabled = isEqual(
    omit(draftFilters, ['search', 'page', 'limit']),
    omit(filters, ['search', 'page', 'limit']),
  );

  return {
    filters: draftFilters,
    partnerShortOptions: partnerShortOptions.map(o => ({
      value: o.id,
      label: o.name,
    })),
    operatorShortOptions: operatorShortOptions.map(o => ({
      value: o.id,
      label: o.name,
    })),
    resetFilters,
    handleApply: applyDraftFilters,
    isResetDisabled,
    isApplyDisabled,
    handleChangeOperatorFilter,
    handleChangePartnerFilter,
    handleChangeStateFilter,
    handleToggleFiltersCard,
  };
};
